import { GetListResult, GetOneResult } from "react-admin";
import HttpClient from "../HttpClient";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";
import {ChefForPartyResponse} from "../interfaces/ChefForParty/ChefForPartyResponse";
import httpClient from "../HttpClient";
import {CategoryResponse} from "../interfaces/StarChefVisit/CategoryResponse";
import { CouponProductType } from "../enums/CouponTypeEnum";
import Op from "../interfaces/SequalizeFilters/SequalizeTypes";
import moment from "moment";
import { PaymentStatusEnum } from "../enums/PaymentStatusEnum";
import DeniedCookInterface from "../interfaces/Cook/DeniedCookInterface";

class ChefForPartyService {

    processDateRangeFilter(filters: any) {
        let createdAt;
        if (filters?.startDate) {
            createdAt = {
                [Op.gte.toString()]: moment(filters?.startDate)
            }
        }
        if (filters?.endDate) {
            if (createdAt) {
                createdAt = {
                    ...createdAt,
                    [Op.lte.toString()]: moment(filters?.endDate)
                }
            } else {
                createdAt = {
                    [Op.lte.toString()]: moment(filters?.endDate)
                }
            }
        }
        return {createdAt};
    }


    processOwnerFilter(filters:any){
        let ownerEmail;
        if(filters?.ownerEmail===undefined){
          return {}
        }
        if(filters?.ownerEmail === 'none'){
          ownerEmail={
            [Op.eq.toString()]: null
          }
        }
        else {
          ownerEmail={
            [Op.eq.toString()]: filters?.ownerEmail?.toString()?.trim()
          }
        }
        return {ownerEmail};
    }

    processPartyDateRangeFilter(filters: any) {
        let date;
        if (filters?.startPartyDate) {
            date = {
                [Op.gte.toString()]: moment(filters?.startPartyDate)
            }
        }
        if (filters?.endPartyDate) {
            if (date) {
                date = {
                    ...date,
                    [Op.lte.toString()]: moment(filters?.endPartyDate)
                }
            } else {
                date = {
                    [Op.lte.toString()]: moment(filters?.endPartyDate)
                }
            }
        }
        return date ? {date} : {};
    }

    paymentFilter(filters: any) {
        if(!filters?.anyPaymentRecieved) {
          return {};
        }
        if(filters?.anyPaymentRecieved === 'Yes'){
          return {
            [Op.or.toString()]: [
                {
                    [Op.and.toString()]: [
                        { tokenAmountPaymentStatus: { [Op.eq.toString()]: PaymentStatusEnum.PAID } },
                        { tokenAmount: { [Op.gt.toString()]: 200 } }
                    ]
                },
                { partialPaymentStatus: {[Op.eq.toString()]: PaymentStatusEnum.PAID }},
                { remainingAmountPaymentStatus: {[Op.eq.toString()]: PaymentStatusEnum.PAID }},
                { remainingAmountPaymentStatus: {[Op.eq.toString()]: PaymentStatusEnum.PARTIAL_PAID }}
            ]
          }
        }else {
            return {
                [Op.and.toString()]: [
                    { partialPaymentStatus: {[Op.not.toString()]: PaymentStatusEnum.PAID }},
                    { remainingAmountPaymentStatus: {[Op.not.toString()]: PaymentStatusEnum.PAID }},
                    { remainingAmountPaymentStatus: {[Op.not.toString()]: PaymentStatusEnum.PARTIAL_PAID }}
                ]
              }
        }
      }

    
    processCookFilters(filters: any) {
        let cookFilters = {};
        if (filters?.cookName) {
            cookFilters = {
                ...cookFilters,
                cookName: {
                    [Op.like.toString()]: `%${filters?.cookName}%`
                }
            }
        }
        if (filters?.cookId) {
            cookFilters = {
                ...cookFilters,
                cookId: {
                    [Op.eq.toString()]: Number(filters?.cookId)
                }
            }
        }
        return cookFilters;
    }

    async fetchOneChefForParty(id: number): Promise<GetOneResult<ChefForPartyResponse>> {
        let data = await HttpClient.get(`/centaurus/chef-for-party/${id}`);
        return data;
    }

    private additionalDetailFilters: { key: string, value: string }[] = [];
    private isFilterExists(newFilter: { key: string, value: string }): boolean {
        return this.additionalDetailFilters.some(filter =>
            filter.key === newFilter.key && filter.value === newFilter.value
        );
    }

    async fetchAllChefForPart(limit: number, offset: number, filters :  any, sort = {}){
        if (filters && filters?.key && filters?.value) {
            const newFilter = { key: filters.key, value: filters.value };
            if (!this.isFilterExists(newFilter)) {
              this.additionalDetailFilters.push(newFilter);
            }
            delete filters?.key;
            delete filters?.value;
        }
        
        let defaultFilters = ConstructSequelizeFilters(filters, ['customerPhone'], ['id', 'tokenAmountPaymentStatus','remainingAmountPaymentStatus', 'time', 'date','cityId', 'bookingType'], [], [], ['status','trackingStatus']);
        
        let customFilters = this.processDateRangeFilter(filters);
        let partyDateRangeFilter = this.processPartyDateRangeFilter(filters)
        let paymentFilters = this.paymentFilter(filters);
        let includes = this.processCookFilters(filters);
        let ownerFilter = this.processOwnerFilter(filters);
        let additional = filters.additionalDetailFilters;
        filters = {
            ...defaultFilters,
            ...customFilters,
            ...paymentFilters,
            ...partyDateRangeFilter,
            ...ownerFilter,
        }
        
        let data = await HttpClient.get('/centaurus/chef-for-party', {
            params: {
                limit,
                offset,
                filters,
                sort,
                includes,
                ...(additional && { additionalDetailFilters: additional}),
            }
        });
        return {
            data: (!!data && !!data.data) ? data.data.data : [],
            total: (!!data && !!data.data) ? data.data.count : 0
        }
    }

    async fetchAllChefForPartyForCook(limit: number, offset: number, filters = {}, sort = {}){
        let includes = this.processCookFilters(filters);
        filters = ConstructSequelizeFilters(filters, ['customerPhone'], ['status','tokenAmountPaymentStatus','remainingAmountPaymentStatus', 'time', 'date','cityId']);
        let data = await HttpClient.get('/centaurus/chef-for-party', {
            params: {
                limit,
                offset,
                filters,
                sort,
                includes,
            }
        });
        return data?.data;
    }

    async createChefForPartyService(data: any): Promise<ChefForPartyResponse> {
        let res = await HttpClient.post(`/centaurus/chef-for-party`, data);
        return res?.data;
    }

    async editChefForPartyService(id: number,data: any): Promise<ChefForPartyResponse> {
        let res = await HttpClient.patch(`/centaurus/chef-for-party/${id}/edit`, data);
        return res?.data;
    }

    async assignCookToChefForParty(entityId: number, payload : any){
        let data = await httpClient.patch(`/centaurus/chef-for-party/${entityId}/assign-cook`, payload)
        return data?.data;
    }

    async approvalChefForParty(id : number, payload : any){
        let data = await httpClient.post(`/centaurus/chef-for-party/${id}/approval`, payload)
        return data?.data;
    }

    async addDIshChefForParty(id: number, payload: any): Promise<ChefForPartyResponse> {
        // Drop any soft-deleted dishes before reconciling. The admin response includes
        // soft-deleted rows (paranoid: false), and sending them back would resurrect
        // previously removed dishes on every add/delete.
        const activeDishes = (payload?.dishes ?? []).filter((dish: any) => !dish?.deletedAt);
        const normalDishes = activeDishes.filter((dish: any) => dish?.dish || dish?.category);
        const customDishes = activeDishes.filter((dish: any) => normalDishes?.indexOf(dish) === -1);
        payload = {
            dishIds: normalDishes.map((dish: any) => dish?.dish?.id || dish?.id),
            customDishes: customDishes.map((dish: any) => {
                return {
                    "dishName": dish?.dishName,
                    "mealType": dish?.mealType,
                    "type": dish?.type,
                    "categoryId": dish?.categoryId,
                }
            })
        }
        let data = await HttpClient.post(`/centaurus/chef-for-party/${id}/add-dish`, payload);
        return data?.data;
    }

    async getAllCategory(): Promise<GetListResult<CategoryResponse>> {
        let data = await HttpClient.get('/cuisine/categories');
        return data?.data;
    }

    async getAllDishesForCategory(categoryId: number): Promise<GetListResult<CategoryResponse>> {
        let data = await HttpClient.get(`/cuisine/categories/${categoryId}`);
        return data?.data;
    }

    async getAllDishesForTypeAndCategory(categoryId: number, mealType: string): Promise<GetListResult<CategoryResponse>> {
        let data = await HttpClient.get(`/cuisine/categories/${categoryId}`, { params : { mealType } });
        return data?.data;
    }

    async getAllDishes(){
        let data = await HttpClient.get('/cuisine/dishes?limit=1000&offset=0');
        return data?.data;
    }

    async cancelChefForParty(id: number, payload: any): Promise<ChefForPartyResponse> {
        let data = await HttpClient.post(`/centaurus/chef-for-party/${id}`, payload);
        return data?.data;
    }

    async updateChefForPartyOrderAmount(id: number, orderId: number, payload: any): Promise<ChefForPartyResponse> {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${id}/order/${orderId}/edit-price`, payload);
        return data?.data;
    }

    async reScheduleChefForParty(id: number, payload: any): Promise<ChefForPartyResponse> {
        let data = await HttpClient.post(`/centaurus/chef-for-party/${id}/reschedule`, payload);
        return data?.data;
    }

    async reschedulePreview(id: number, payload: any): Promise<any> {
        let data = await HttpClient.post(`/centaurus/chef-for-party/${id}/reschedule/preview`, payload);
        return data?.data;
    }

    async updateAllocationComment(id: number, payload: any): Promise<ChefForPartyResponse> {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${id}/allocation-comment`, {
            type: 'ALLOCATOR_COMMENT',
            ...payload,
        });
        return data?.data;
    }

    async updateCustomerComment(id: number, payload: any): Promise<ChefForPartyResponse> {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${id}/customer-comment`, {
            type: 'CUSTOMER_COMMENT',
            ...payload,
        });
        return data?.data;
    }

    async updateSupplyComment(id: number, payload: any): Promise<ChefForPartyResponse> {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${id}/supply-comment`, {
            type: 'SUPPLY_COMMENT',
            ...payload,
        });
        return data?.data;
    }

    async sendPaymentLink(id: number, orderId: number): Promise<GetOneResult<ChefForPartyResponse>> {
        let data = await HttpClient.post(`/centaurus/chef-for-party/${id}/order/${orderId}/send-payment-link`);
        return data?.data;
    }

    async initiateRefund(id: number, orderId: number, payload: any): Promise<GetOneResult<ChefForPartyResponse>> {
        let data = await HttpClient.post(`/centaurus/chef-for-party/${id}/order/${orderId}/refund`, payload);
        return data?.data;
    }

    async calculateDynamicPrice(payload: any): Promise<GetOneResult<ChefForPartyResponse>> {
        let data = await HttpClient.post(`/customer/chef-for-party/calculate-price`, payload);
        return data?.data;
    }

    async getAllCoupon(houseId: number, bookingType: string){
        let data = await HttpClient.get(`/centaurus/v4/coupon/${bookingType === "BOOK_BY_DISH" ? CouponProductType.BOOK_BY_DISH : CouponProductType.CHEF_FOR_PARTY}/houses/${houseId}`);
        return data?.data;
    }

    async changeCoupon(partyId: number, payload: any){
        let data = await HttpClient.post(`/centaurus/chef-for-party/${partyId}/change-coupon`, payload);
        return data?.data;
    }

    async removeDish(partyId: number, dishId: number){
        let data = await HttpClient.delete(`/centaurus/chef-for-party/${partyId}/dish/${dishId}`);
        return data?.data;
    }

    async removeCook(partyId: number, cookId: number){
        let data = await HttpClient.delete(`/centaurus/chef-for-party/${partyId}/cook/${cookId}`);
        return data?.data;
    }

    async markAsFulFilled(partyId: number){
        let data = await HttpClient.post(`/centaurus/chef-for-party/${partyId}/mark-fulfilled`);
        return data?.data;
    }

    async markAsOnGoing(partyId: number){
        let data = await HttpClient.post(`/centaurus/chef-for-party/${partyId}/mark-ongoing`);
        return data?.data;
    }

    async getChefForPartyForHouse(houseId: number,limit: number, offset: number, filters = {}, sort = {}): Promise<GetListResult<ChefForPartyResponse>> {
        let data = await HttpClient.get(`/centaurus/chef-for-party/house/${houseId}`, {
            params: {
                limit,
                offset,
                filters,
                sort,
            }
        });
        return {
            data: (!!data && !!data.data) ? data.data.data : [],
            total: (!!data && !!data.data) ? data.data.count : 0
        }
    }

    async getChefForPartyForCustomer(userId: number, limit: number, offset: number, sort = {}): Promise<GetListResult<ChefForPartyResponse>> {
        const filters = { userId: { [Op.eq.toString()]: userId } };
        let data = await HttpClient.get('/centaurus/chef-for-party', {
            params: { limit, offset, filters, sort }
        });
        return {
            data: data?.data?.data ?? [],
            total: data?.data?.count ?? 0,
        };
    }

    async updateChefForPartyPaymentStatus(id: number, payload: any) {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${id}/update-chefforparty-payment-status`, payload);
        return data?.data;
      }

    async updatePartyAmountToBeCollected(id: number) {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${id}/amount_to_be_collected`);
        return data?.data;
    }

    async preCheckIn(serviceId:number, cookId: number){
        let data = await HttpClient.post(`/centaurus/chef-for-party/${serviceId}/cook/${cookId}/pre-checkin`)
        return data;
    }

    async generateIngredientsList(partyId: number) {
        let data = await HttpClient.post(`centaurus/chef-for-party/${partyId}/generate-ingredient-list`);
        return data?.data;
    }

    async updateIngredientListVerificationStatus(
        partyId: number,
        verificationStatus: boolean
    ) {
        let data = await HttpClient.patch(
            `/centaurus/chef-for-party/${partyId}/ingredient-list-verification-status`,
            {},
            { params: { verificationStatus } }
        );
        return data?.data;
    }

    async cashCollected(partyId: number) {
        let payload = {
            isCashCollected: true
        }
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/cash-collected`, payload);
        return data?.data;
    }

    async getAllIngredientsForParty(limit: number, offset: number, filters = {}, sort = {}) {
        let data = await HttpClient.get(`/centaurus/chef-for-party/get-all-ingredients`, {
            params: {
                limit,
                offset,
                filters,
                sort,
            }
        });
        return {
            data: (!!data && !!data.data) ? data.data.data : [],
            total: (!!data && !!data.data) ? data.data.count : 0
        }
    }

    async addIngredientToParty(partyId: number, payload: any) {
        let data = await HttpClient.post(`/centaurus/chef-for-party/${partyId}/add-ingredient`, payload);
        return data?.data;
    }

    async updateOccasion(partyId: number, payload: any) {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/update-occasion`, payload);
        return data?.data;
    }

    async updateChefForPartyCookExtraDetails(partyId: number, cookId: number,payload: any) {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/cook/${cookId}/update-extra-details`, payload);
        return data?.data;
    }
    async convertToFullPaymentOrder(partyId: number){
        let data = await HttpClient.patch(`/centaurus/chef-for-party/convert-party-to-full-payment/${partyId}`);
        return data?.data;
    }

    async updateAgentEta(id: number, agentExpectedArrivalTime: string) {
        const res = await HttpClient.patch(`/centaurus/chef-for-party/${id}/agent-eta`, {
            agentExpectedArrivalTime,
        });
        return res?.data;
    }

    async updatePartyPreferences(partyId: number, payload: any) {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/party-preferences`, payload);
        return data?.data;
    }

    async updateExtraDetails(partyId: number, payload: any) {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/extra-details`, payload);
        return data?.data;
    }
    async changeChefForPartyTime(id: number, payload: any) {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${id}/change-time`, payload);
        return data?.data;
    }

    async getVendorPayoutForChefForParty(chefForPartyId: number): Promise<GetListResult<any>> {
        let data = await HttpClient.get(`/centaurus/chef-for-party/${chefForPartyId}/vendor-payout`);
        return data?.data;
    }

    async addAllocationComment(allocationId: number, comment: any): Promise<GetListResult<any>> {
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${allocationId}/add-allocation-comment`,comment);
        return data?.data;
    }

    async getAcceptedLeadForParty(serviceId: number,  limit: number, offset: number, sort: any){
        let data = await HttpClient.get(`/centaurus/chef-for-party/${serviceId}/accepted-leads`, {
          params: {
            limit,
            offset,
            sort,
        }
        })
        return data;
    }
    async acceptLeadForParty(allocationId: number,  accepted: boolean){
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${allocationId}/accept-lead`,{accepted})
        return data;
    }

    async updateDeleteIngredient(partyId: number, payload: any){
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/update-remove-ingredient`,payload);
        return data;
    }

    async addQuotedPrice(partyId: number, payload: any){
      let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/quoted-cook-cut`,{},{ params: payload });                // PATCH body (empty if you only need query params)
      return data;
    }

    async updateLeadTag(partyId: number, payload: any){
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/update-party-tag`,payload);
        return data;
    }

    async updatePartyStatus(partyId: number, payload: any){
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/update-party-status`,payload);
        return data;
    }
    async allowLatePaymet(partyId: number){
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/allow-late-payment`);
        return data;
    }

    async denyParty(partyId: number, cookId: number, payload: any){
        let data = await HttpClient.patch(`/centaurus/chef-for-party/${partyId}/cook/${cookId}/cook-denied-service`, payload);
        return data;
    }

    async getAllDenialsByPartyId(partyId: number): Promise<DeniedCookInterface[]> {
        let data = await HttpClient.get(`/centaurus/chef-for-party/${partyId}/get-denied-cooks`);
        return data?.data;
    }

    async revertCookDenial(denialId: number){
        let data = await HttpClient.delete(`/centaurus/chef-for-party/denial/${denialId}`);
        return data;
    }

    async toggleDenialEmergencyStatus(cancelId: number){
        let data = await HttpClient.patch(`/centaurus/chef-for-party/denial/${cancelId}/emergency`);
        return data?.data;
    }

    async generateAutoAllocateCookList(partyId: number){
        let data = await HttpClient.post(`/centaurus/chef-for-party/${partyId}/generate-allocate-cook-list`);
        return data?.data;
    }

    async getBookByDishProposals(partyId: number): Promise<any[]> {
        let data = await HttpClient.get(`/centaurus/book-by-dish/visit/${partyId}/proposals`);
        return data?.data;
    }

    async approveBookByDishProposals(partyId: number): Promise<any> {
        let data = await HttpClient.post(`/centaurus/book-by-dish/visit/${partyId}/proposals/approve`);
        return data?.data;
    }

    async rejectBookByDishProposals(partyId: number): Promise<any> {
        let data = await HttpClient.post(`/centaurus/book-by-dish/visit/${partyId}/proposals/reject`);
        return data?.data;
    }

    async processLunchMoney(partyId: number, payload: { amount: number; comments?: string }): Promise<any> {
        let data = await HttpClient.post(`/centaurus/chef-for-party/${partyId}/lunch-money`, payload);
        return data?.data;
    }

    async processFarVisitIncentive(partyId: number, payload: { amount: number; comments?: string }): Promise<any> {
        let data = await HttpClient.post(`/centaurus/chef-for-party/${partyId}/far-visit-incentive`, payload);
        return data?.data;
    }

    async auditLogs(partyId: number) {
        let data = await HttpClient.get(`/centaurus/chef-for-party/${partyId}/audit-logs`);
        return data?.data;
    }
}
export default ChefForPartyService;
